import { render } from "./CourseRelate.vue?vue&type=template&id=5747df40&scoped=true"
import script from "./CourseRelate.vue?vue&type=script&lang=js"
export * from "./CourseRelate.vue?vue&type=script&lang=js"

import "./CourseRelate.vue?vue&type=style&index=0&id=5747df40&lang=scss&scoped=true"

import exportComponent from "C:\\programs\\dd2.0\\dw-dwms-mini\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5747df40"]])

export default __exports__